import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import { displayErrorToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { projectListRequest } from '../../../redux/project/project.action'
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import TopButton from "../../../components/button/top-button/topButton";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import moment from "moment";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";

const ProjectList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { projectListSuccess, projectListError } = useSelector(state => state.project)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [selectedTab, setSelectedTab] = useState(0)
    const DEFAULT_STATUS = {
        key: 'ALL', value: 'All'
    }
    const STATUS_LIST = [
        DEFAULT_STATUS,
        { key: APP_CONSTANTS.PROJECT_STATUS.NEW, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.NEW) },
        { key: APP_CONSTANTS.PROJECT_STATUS.PENDING, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.PENDING) },
        { key: APP_CONSTANTS.PROJECT_STATUS.IN_PROGRESS, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.IN_PROGRESS) },
        { key: APP_CONSTANTS.PROJECT_STATUS.COMPLETE, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.COMPLETE) },
        { key: APP_CONSTANTS.PROJECT_STATUS.ON_HOLD, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.ON_HOLD) },
        { key: APP_CONSTANTS.PROJECT_STATUS.CANCELLED, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.PROJECT_STATUS.CANCELLED) },
    ]
    const [selectedStatus, setSelectedStatus] = useState(DEFAULT_STATUS)

    const TAB_ITEMS = {
        ALL: 'ALL',
        ASSIGNED_PROJECT: 'ASSIGNED PROJECT'
    }

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.PROJECT_LIST, true)
            fetchBusinessList()
        }
        if (isLoggedInUserEmployee(user)) {
            fetchProjectList(0)
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.PROJECT_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.PROJECT_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(projectListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(projectListError)) {
            setLoading(false)
        }
    }, [projectListSuccess, projectListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(selectedLocation) && isLoggedInUserBusiness(user)) {
            fetchProjectList(0)
        }
    }, [selectedLocation])

    const fetchProjectList = (selectedTab) => {
        setLoading(true)
        const data = {}
        if (isLoggedInUserBusiness(user)) {
            if (!isEmpty(selectedBusiness)) {
                data.businessId = selectedBusiness.businessId
                data.locationId = selectedLocation.locationId
            }
        }
        if (isLoggedInUserEmployee(user)) {
            data.businessId = employeeSelectedBusiness
            data.locationId = employeeSelectedLocation
        }
        if (selectedTab === 1) {
            data.employeeId = user.data.userDetails.employeeId
            data.userType = user.data.userDetails.userType
        }
        if (!isEmpty(selectedStatus) && selectedStatus.key !== DEFAULT_STATUS.key) {
            data.projectStatus = selectedStatus.key
        }
        dispatch(projectListRequest(data))
    }

    const handleAddProjectClick = () => {
        navigate(ROUTES.project.addProject)
    }

    const handleViewDetail = element => {
        if (isLoggedInUserBusiness(user) && isNull(selectedBusiness) && isNull(selectedLocation)) {
            displayErrorToast('Business and location not selected')
        } else {
            navigate(ROUTES.project.detail, {
                state: {
                    projectId: element.projectId,
                    businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
                }
            })
        }
    }

    const handleTabSelect = (item) => {
        if (item === TAB_ITEMS.ALL) {
            setSelectedTab((prevTab) => {
                const newTab = 0
                fetchProjectList(0)
                return newTab
            })
        } else {
            setSelectedTab((prevTab) => {
                const newTab = 1
                fetchProjectList(1)
                return newTab
            })
        }
    }

    useEffect(() => {
        if (!isEmpty(selectedStatus)) {
            fetchProjectList(selectedTab)
        }
    }, [selectedStatus])

    const getStatusClassName = (status) => {
        if (status === APP_CONSTANTS.PROJECT_STATUS.COMPLETE) {
            return 'al-status-label al-status-green'
        } else if (status === APP_CONSTANTS.PROJECT_STATUS.NEW) {
            return 'al-status-label al-status-grey'
        } else if (status === APP_CONSTANTS.PROJECT_STATUS.CANCELLED) {
            return 'al-status-label al-status-red'
        } else if (status === APP_CONSTANTS.PROJECT_STATUS.ON_HOLD) {
            return 'al-status-label al-status-purple'
        } else if (status === APP_CONSTANTS.PROJECT_STATUS.PENDING) {
            return 'al-status-label al-status-yellow'
        } else if (status === APP_CONSTANTS.PROJECT_STATUS.IN_PROGRESS) {
            return 'al-status-label al-status-orange'
        } else {
            return 'al-status-label'
        }
    }

    const getStatusClassNameTab = (e, selectedStatus) => {
        if (e.key === APP_CONSTANTS.PROJECT_STATUS.PENDING) {
            if (selectedStatus.key === APP_CONSTANTS.PROJECT_STATUS.PENDING) {
                return 'tl-status-item tl-status-item-selected-yellow'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === APP_CONSTANTS.PROJECT_STATUS.COMPLETE) {
            if (selectedStatus.key === APP_CONSTANTS.PROJECT_STATUS.COMPLETE) {
                return 'tl-status-item tl-status-item-selected-green'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === APP_CONSTANTS.PROJECT_STATUS.CANCELLED) {
            if (selectedStatus.key === APP_CONSTANTS.PROJECT_STATUS.CANCELLED) {
                return 'tl-status-item tl-status-item-selected-red'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === APP_CONSTANTS.PROJECT_STATUS.NEW) {
            if (selectedStatus.key === APP_CONSTANTS.PROJECT_STATUS.NEW) {
                return 'tl-status-item tl-status-item-selected-grey'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === APP_CONSTANTS.PROJECT_STATUS.IN_PROGRESS) {
            if (selectedStatus.key === APP_CONSTANTS.PROJECT_STATUS.IN_PROGRESS) {
                return 'tl-status-item tl-status-item-selected'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === APP_CONSTANTS.PROJECT_STATUS.ON_HOLD) {
            if (selectedStatus.key === APP_CONSTANTS.PROJECT_STATUS.ON_HOLD) {
                return 'tl-status-item tl-status-item-selected-purple'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === DEFAULT_STATUS.key) {
            if (selectedStatus.key === DEFAULT_STATUS.key) {
                return 'tl-status-item tl-status-item-selected-dark-green'
            } else {
                return 'tl-status-item'
            }
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Projects' />
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                <div className="tl-status-row-container">
                    {!isEmpty(STATUS_LIST) && <div className="tl-status-parent-container">
                        <div className="tl-status-container">
                            {STATUS_LIST.map(e => (
                                <div className={getStatusClassNameTab(e, selectedStatus)} onClick={() => setSelectedStatus(e)}>{e.value}</div>
                            ))}
                        </div>
                    </div>}
                </div>
                {isLoggedInUserEmployee(user) && <div className="al-tab-row-container">
                    <div
                        className={`al-row-item-container ${selectedTab === 0 ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_ITEMS.ALL) }}>{TAB_ITEMS.ALL}</div>
                    <div
                        className={`al-row-item-container ${selectedTab === 1 ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_ITEMS.ASSIGNED_PROJECT) }}>{TAB_ITEMS.ASSIGNED_PROJECT}</div>
                </div>}
                {!isNull(projectListSuccess) && !isEmpty(projectListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Customer</th>
                                <th scope="col" className="text-center">Customer Type</th>
                                <th scope="col" className="text-center">Status</th>
                                <th scope="col" className="text-center">Start Date</th>
                                <th scope="col" className="text-center">End Date</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {projectListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.name}</td>
                                    <td className="text-center">{!isEmpty(element.customerBusinessName) ? element.customerBusinessName : element.customerName}</td>
                                    <td className="text-center">{removeSpecialCharAndChangeToPascal(element.customerType)}</td>
                                    <td className="text-center">
                                        <div className={getStatusClassName(element.projectStatus)}>
                                            {removeSpecialCharAndChangeToPascal(element.projectStatus)}
                                        </div>
                                    </td>
                                    <td className="text-center">{moment.utc(element.startDate).local().format('DD MMM YYYY')}</td>
                                    <td className="text-center">{moment.utc(element.endDate).local().format('DD MMM YYYY')}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleViewDetail(element) }}><div className="tr-action-btn">View Details</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(projectListError) && <div className="content-error">{projectListError.message}</div>}
                {checkFunctionalityPermission(user, PERMISSION_TYPE.PROJECT, PERMISSION_SUB_TYPE.PROJECT.ADD_PROJECT, employeeSelectedBusiness, employeeSelectedLocation) &&
                    <div className="vl-fab-container" onClick={() => handleAddProjectClick()}>
                        <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                    </div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default ProjectList